<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>账户资金一键归拢</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom1">
		<div v-for="(item,index) in data" class="z-subAccount-item">
			<img :src="item.avatar" class="z-user-avatar">
			<div class="z-subAccount-info">
				<div v-text="item.name"></div>
				<div v-text="'交易号：'+(item.trade_account ? item.trade_account : '待入金')"></div>
				<div v-text="'收益金：'+item.profit+'  ；推广金：'+item.extend+'；代理金：'+item.agent"></div>
				<div v-text="'感恩奖：'+item.owes+'  ；通证奖：'+item.passcard"></div>
			</div>
		</div>
	</div>
	<div class="z-gather-box">
		<div class="z-gather-amount">
			<div>
				<span v-text="amount.profit"></span>
				<span>收益金</span>
			</div>
			<div>
				<span v-text="amount.extend"></span>
				<span>推广金</span>
			</div>
			<div>
				<span v-text="amount.agent"></span>
				<span>代理金</span>
			</div>
			<div>
				<span v-text="amount.owes"></span>
				<span>感恩奖</span>
			</div>
			<div>
				<span v-text="amount.passcard"></span>
				<span>通证奖</span>
			</div>
		</div>
		<div class="z-btn-long z-gather-btn" @click="isShow=true">一键归集</div>

    <v-dialog v-model="isShow" scrollable max-width="300px">
    	<v-card light>
    	<v-card-title class="headline">提示</v-card-title>
    	<v-card-text>确定一键归集么？</v-card-text>
    	<v-card-actions>
    	<v-spacer></v-spacer>
    	<v-btn color="green darken-1" flat="flat" @click="isShow=false">关闭</v-btn>
    	<v-btn color="green darken-1" flat="flat" @click="merger">确定</v-btn>
    	</v-card-actions>
    	</v-card>
    </v-dialog>
	</div>
</div>
</template>

<script>
export default {
	name: 'gather',
	data() {
		return {
			data:[],
			amount:{
				profit:0,
				extend:0,
				agent:0,
				owes:0,
				passcard:0,
				total:0
			},

      isShow:false
		}
	},
	created() {
		this.init()
	},
	methods: {
		init(){
			this.get('api/UserAccount/childLists',{}).then((rs)=>{
				if (rs.code==0) {
					this.data = rs.data.lists
					this.amount = rs.data.total
				}
			})
		},
		merger(){
			this.post('api/UserAccount/merger',{}).then((rs)=>{
				if (rs.code==0) {
					this.init()
				}
        this.$store.commit('layer',rs.msg)
        this.isShow = false
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	align-items:center;
	padding: 5px 10px;
	/* border-bottom: 1px solid #27292F; */
  border-bottom: 1px solid #515151;
}
.z-subAccount-info div:nth-child(2),
.z-subAccount-info div:nth-child(3),
.z-subAccount-info div:nth-child(4) {
	font-size: 10px;
	color: #9B9A9C;
}
.z-icon {
	width: 18px;
	height: 18px;
}
.z-gather-box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	background: #fff;
	/* border-top: 2px solid #1E1F22; */
  border-top: 2px solid #515151;
}
.z-gather-amount,
.z-gather-amount>div{
	display: -webkit-flex;
	display: flex;
	align-items:center;
	justify-content:space-around;
}
.z-gather-amount {
	margin: 15px 0px;
}
.z-gather-amount>div {
	flex-direction:column;
	width: 33%;
}
.z-gather-amount>div:nth-child(1),
.z-gather-amount>div:nth-child(2),
.z-gather-amount>div:nth-child(3),
.z-gather-amount>div:nth-child(4) {
	border-right: 1px solid #9B9A9C;
}
.z-gather-amount>div span:nth-child(1) {
	color:#C19F62;
}
.z-gather-amount>div span:nth-child(2) {
	color:#9B9A9C;
}
.z-gather-btn{
	border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/gather.vue